import React from "react";

export const DecreaseIcon = ({
  width = 43.549,
  height = 44.868,
  fill = "#7a7373",
  className = "",
  ...rest
}) => {
  return (
    <svg
      id="Component_35_9"
      data-name="Component 35 – 9"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 43.549 44.868"
    >
      <g
        id="Path_37476"
        data-name="Path 37476"
        transform="translate(17.082) rotate(30)"
        fill="none"
        strokeLinejoin="bevel"
      >
        <path
          d="M30.561,24.938V9.226a1.345,1.345,0,0,0-.681-1.163L15.929.174a1.3,1.3,0,0,0-1.3,0L.681,8.063A1.345,1.345,0,0,0,0,9.226V24.938A1.345,1.345,0,0,0,.681,26.1L14.633,33.99a1.3,1.3,0,0,0,1.3,0L29.88,26.1A1.345,1.345,0,0,0,30.561,24.938Z"
          stroke="none"
        />
        <path
          d="M 15.28073883056641 33.16407012939453 C 15.33253860473633 33.16407012939453 15.38364887237549 33.15038299560547 15.4285192489624 33.12446975708008 L 15.436279296875 33.12002944946289 L 29.38665962219238 25.23144149780273 C 29.49345207214355 25.17078971862793 29.56034469604492 25.05703163146973 29.56147956848145 24.93431091308594 L 29.56147956848145 9.229762077331543 C 29.56034469604492 9.107040405273438 29.49346923828125 8.993295669555664 29.38825798034668 8.933550834655762 L 15.4285192489624 1.03960120677948 C 15.33877849578857 0.9877814054489136 15.22269916534424 0.9877814054489136 15.13295841217041 1.03960120677948 L 15.12519836425781 1.044041275978088 L 1.174808859825134 8.932651519775391 C 1.068024754524231 8.993291854858398 1.001132130622864 9.107049942016602 0.9999988079071045 9.229782104492188 L 0.9999988079071045 24.93428039550781 C 1.001132130622864 25.05702209472656 1.068019032478333 25.1707878112793 1.173218846321106 25.23053169250488 L 15.13295841217041 33.12446975708008 C 15.17782878875732 33.15038299560547 15.22893905639648 33.16407012939453 15.28073883056641 33.16407012939453 M 15.28073883056641 34.16406631469727 C 15.05706405639648 34.16406631469727 14.83338928222656 34.1062126159668 14.63296890258789 33.99050140380859 L 0.6809888482093811 26.10100173950195 C 0.2622988224029541 25.86322212219238 0.002588830655440688 25.4198112487793 -1.169433630821004e-06 24.93832206726074 L -1.169433630821004e-06 9.225741386413574 C 0.002588830655440688 8.744251251220703 0.2622988224029541 8.300850868225098 0.6809888482093811 8.063080787658691 L 14.63296890258789 0.1735712438821793 C 15.03380966186523 -0.05785874277353287 15.52766799926758 -0.05785874277353287 15.92850875854492 0.1735712438821793 L 29.88048934936523 8.063080787658691 C 30.29917907714844 8.300850868225098 30.55889892578125 8.744251251220703 30.56147956848145 9.225741386413574 L 30.56147956848145 24.93833160400391 C 30.55889892578125 25.41983032226562 30.29917907714844 25.86322212219238 29.88048934936523 26.10100173950195 L 15.92850875854492 33.99050140380859 C 15.72808837890625 34.1062126159668 15.50441360473633 34.16406631469727 15.28073883056641 34.16406631469727 Z"
          stroke="none"
          fill={fill}
        />
      </g>
      <path
        id="minus-solid"
        className="path"
        d="M19.466,225.5a1.5,1.5,0,0,1-1.5,1.5H1.5A1.5,1.5,0,1,1,1.5,224H17.969A1.5,1.5,0,0,1,19.466,225.5Z"
        transform="translate(11.583 -203.063)"
        fill={fill}
      />
    </svg>
  );
};
